import { render, staticRenderFns } from "./claim-tasks.vue?vue&type=template&id=19630f36&"
import script from "./claim-tasks.vue?vue&type=script&lang=ts&"
export * from "./claim-tasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports